// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"6a8a7a711d73044ca7a2","691":"599283ee1e1079b47a38"}[chunkId] + ".js";
};